import { Component, Element, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";

@Component({
    tag: "ux-file-upload-thumbnail",
    styleUrl: "file-upload-thumbnail.scss",
    shadow: true
})
export class FileUploadThumbnail {
    @Element() element!: HTMLUxFileUploadThumbnailElement;

    /**
     * The file type of the associated file
     */
    @Prop() readonly fileType: string = "";

    /**
     * The file itself to render an image thumbnail
     */
    @Prop() readonly file: File | null = null;

    /**
     * The file name of the associated file
     */
    @Prop() readonly fileName: string = "";

    /**
     * The data-file-input-id of the associated file input
     */
    @Prop() readonly fileInputId: string = "";

    /**
     * Indicates if the file is an image
     */
    @State() isImageFile = false;

    /**
     * The icon name based on the file type
     */
    @State() iconName = "";

    private getIconName = () => {
        if (this.fileType === "application/pdf") {
            return "file-pdf";
        } else {
            return "file-generic";
        }
    };

    connectedCallback() {
        this.isImageFile = this.fileType.startsWith("image/");
    }

    componentDidLoad() {
        if (!this.isImageFile) {
            this.iconName = this.getIconName();
        } else {
            const img = this.element.ownerDocument.createElement("img");
            // @ts-expect-error Check for typing
            img.file = this.file;
            const reader = new FileReader();
            /* eslint-disable */
            reader.onload = (function (aImg) {
                /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
                return function (e: any) {
                    aImg.src = e.target.result;
                };
            })(img);
            // @ts-expect-error Check for typing
            reader.readAsDataURL(this.file);

            // Append the img element to the Shadow DOM
            // @ts-expect-error Check for typing
            this.element.shadowRoot.appendChild(img);
        }
    }

    /**
     * Handle deletion of file
     */
    @Event({
        eventName: "uxFileUploadDelete",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    fileUploadDelete!: EventEmitter;

    private onDelete = () => {
        this.fileUploadDelete.emit({ fileInputId: this.fileInputId });
    };

    render() {
        return (
            <Host>
                {!this.isImageFile && <ux-icon aria-hidden="true" name={this.iconName} weight="light"></ux-icon>}
                <button id="delete-button" onClick={this.onDelete} type="button">
                    <ux-icon aria-hidden="true" name="bin" weight="normal"></ux-icon>
                </button>
                <ux-tooltip tooltip-target="img" align="bottom">
                    {this.fileName}
                </ux-tooltip>
            </Host>
        );
    }
}
